module.exports = __webpack_public_path__ + "img/4.4.00aa76a5.png";